import { combineReducers } from 'redux';

import { CHART_TYPES } from '../../constants';
import analyticsReducer from '../analyticsReducer';

export default combineReducers({
    [CHART_TYPES.ATTENTION_APMS]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_NEED_ATTENTION',
    }),
    [CHART_TYPES.DISABLED_SUSPICIOUS]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_DISABLED_SUSPICIOUS',
    }),
    [CHART_TYPES.OVERTIME_COUNT]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_HIGHEST_OVERTIME',
    }),
    [CHART_TYPES.SLOT_UTILISATION]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_SLOT_UTILISATION',
    }),
    [CHART_TYPES.TRAY_UTILISATION]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_TRAY_UTILISATION',
    }),
    [CHART_TYPES.UTILISATION_PER_COUNTRY]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_UTILISATION_PER_COUNTRY',
    }),
    [CHART_TYPES.UTILISATION_RATE]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_APMS_UTILISATION_RATE',
    }),
});
